module.exports = __webpack_public_path__ + "static/media/phoneicon.0326c0e7.svg";